'use strict'
const path = require('path')
const defaultSettings = require('./src/settings.js')
// 定义压缩文件类型
const productionGzipExtensions = ['js', 'css']

function resolve(dir) {
	return path.join(__dirname, dir)
}

const name = defaultSettings.title || 'vue Element Admin' // page title

// 是否为生产环境
// const isProduction = process.env.NODE_ENV !== 'development'
const isProduction = true //暂时不区分环境
// 本地环境是否需要使用cdn
const devNeedCdn = true

// cdn链接
const cdn = {
	// cdn：模块名称和模块作用域命名（对应window里面挂载的变量名称）
	externals: {},
	js: []
}
const port = process.env.port || process.env.npm_config_port || 8080 // dev port

// All configuration item explanations can be find in https://cli.vuejs.org/config/
module.exports = {
	publicPath: './',
	outputDir: 'dist',
	assetsDir: 'static',
	lintOnSave: process.env.NODE_ENV === 'development',
	productionSourceMap: true, //设置为true，这里必须设置，否则token读不到还是无法跳转的
	devServer: {
		open: false,
		proxy: {
			'/api': {
				// 测试版
				// target: 'http://canhe-api.ccfr.com.cn',
				target: 'https://mall.ykfalvguwen.com',
				// 正式版
				// target: 'https://www.ccfr.com.cn',
				changeOrigin: true,
				disableHostCheck: true,
				ws: true,
				pathRewrite: {
					'^/api': ''
				}
			}
		}
	},
	configureWebpack: (config) => {
		config.name = name
		config.resolve.alias['@'] = resolve('src')

		config.performance = {
			hints: 'warning',
			//入口起点的最大体积 整数类型（以字节为单位）
			maxEntrypointSize: 50000000,
			//生成文件的最大体积 整数类型（以字节为单位 300k）
			maxAssetSize: 30000000,
			//只给出 js 文件的性能提示
			assetFilter: function (assetFilename) {
				return assetFilename.endsWith('.js')
			}
		}
		if (isProduction) {
			// 生产环境
			// 编译时删除console.log
			config.optimization.minimizer[0].options.terserOptions.compress.warnings = false
			config.optimization.minimizer[0].options.terserOptions.compress.drop_console = true
			config.optimization.minimizer[0].options.terserOptions.compress.drop_debugger = true
			config.optimization.minimizer[0].options.terserOptions.compress.pure_funcs =
				['console.log']
		} else {
			// 开发环境
		}
	},
	chainWebpack(config) {
		// when there are many pages, it will cause too many meaningless requests
		config.plugins.delete('prefetch')
		config.plugins.delete('preload')
		// set svg-sprite-loader
		config.module.rule('svg').exclude.add(resolve('src/icons')).end()
		config.module
			.rule('icons')
			.test(/\.svg$/)
			.include.add(resolve('src/icons'))
			.end()
			.use('svg-sprite-loader')
			.loader('svg-sprite-loader')
			.options({
				symbolId: 'icon-[name]'
			})
			.end()
		config.when(process.env.NODE_ENV !== 'development1', (config) => {
			config
				.plugin('ScriptExtHtmlWebpackPlugin')
				.after('html')
				.use('script-ext-html-webpack-plugin', [
					{
						inline: /runtime\..*\.js$/
					}
				])
				.end()
			config.optimization.splitChunks({
				chunks: 'all',
				cacheGroups: {
					libs: {
						name: 'chunk-libs',
						test: /[\\/]node_modules[\\/]/,
						minChunks: 1, //  minimum common number
						minSize: 0,
						priority: 10,
						chunks: 'initial' // only package third parties that are initially dependent
					},
					commons: {
						name: 'chunk-commons',
						test: resolve('src/components'), // can customize your rules
						minChunks: 3, //  minimum common number
						priority: 5,
						reuseExistingChunk: true
					}
				}
			})
			// https:// webpack.js.org/configuration/optimization/#optimizationruntimechunk
			config.optimization.runtimeChunk('single')
		})

		// -------- 注入cdn start ---------
		config.plugin('html').tap((args) => {
			// 生产环境或本地需要cdn时，才注入cdn
			if (isProduction || devNeedCdn) args[0].cdn = cdn
			return args
		})
		// --------- 注入cdn end ----------
	}
}
